<template>
    <div class="modal" tabindex="-1" role="dialog" id="crew_list" style="padding-right: 16px; display: block">
      <div class="modal-mask" @click.self="$emit('crewListModalClose')">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Crew List</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeCrewListModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-bordered-gap">
              <thead>
                <tr>
                  <th>Employee ID</th>
                  <th>Crew</th>
                  <th>Position</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(cItem,cIdex) in courseCrewList" :key="cItem.employeeNo">
                  <td>{{cItem.employeeNo}}</td>
                  <td>
                    <div>
                        <div class="text-grey">{{cItem.cName}}</div>
                        <div>{{cItem.firstName}} {{cItem.surName}}</div>
                        <div class="text-grey">{{cItem.nickName}}</div>
                    </div>
                  </td>
                  <td><span class="badge badge-secondary">{{cItem.position}}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
   props: {
    currentMission: {
      type: Object,
      default() {
        return {};
      }
    },
    actvType:{
      type: Number,
      default: 3
    },
    impersonate: {
      type: String,
      default: null
    }
  },
  data: () => ({
  }),
  created () {
    this.getCourseCrewListData();
  },
  computed:{
    ...mapGetters(["courseCrewList", "impersonateMail"])
  },
  methods: {
    ...mapActions(["getCourseCrewList"]),
    getCourseCrewListData () {
      if (this.actvType !== 3 && this.actvType !== 9) return;
      const storeEmpId = this.$store.getters.impersonateMail;
      const impersonate = this.impersonate || (storeEmpId ? storeEmpId.split("@")[0] : null);

      const axiosData = {
        rosterStart: this.$moment(this.currentMission.subStartDate).format('YYYY-MM-DD'),
        rosterEnd: this.$moment(this.currentMission.subEndDate).format('YYYY-MM-DD'),
        courseActivityKey: this.currentMission.crseKey,
        subActivityName: this.currentMission.subActvName
      }
      if (impersonate) {
        axiosData.impersonate = impersonate;
      }
      //console.log(axiosData)
      this.getCourseCrewList(axiosData)
    },
    closeCrewListModal () {
      this.courseCrewList.splice(0, this.courseCrewList.length);
      this.$emit('crewListModalClose')
    }
  }
}
</script>

<style lang="scss" scoped>
.table td, .table th {
    vertical-align: top;
}


</style>